import React, { Component } from 'react';
import NoAuthComponent from '../auth/NoAuthComponent';
import BasicAuthComponent from '../auth/BasicAuthComponent';
import BearerAuthComponent from '../auth/BearerAuthComponent';
import { RootState } from '../../../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import FormicaLabel from '../../../../custom/FormicaLabel';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../../../custom/FormicaSearchSelectBox';
import RoleHelper from '../../../../../RoleHelper';
import { FormicaProps, withFormica } from '../../../../../helpers/withFormica';
import { ActionState } from '../../../../../redux/reducers/ActionReducer';
import { changeAction, changeActionIsUpdate, clearAction } from '../../../../../redux/actions/ActionActions';
import { enterComponent, leaveComponent } from '../../../../../redux/actions/ComponentActions';
import { ApiActionJsonModel } from '../../../../../domain/collection/rule/action/ActionDomains';
import ComponentName from '../../../../../constant/ComponentName';
import LanguageUtil from '../../../../../util/LanguageUtil';

class ApiAuthorizationComponent extends Component<Props> {
  public render() {
    const {
      action: { action },
    } = this.props;

    return (
      <div className={'flex flex-col gap-y-4 w-full h-full py-5 px-2'}>
        <div className={'flex flex-col gap-y-2 lg:w-[400px]'}>
          <FormicaLabel label={LanguageUtil.get({ id: 'common.label.type', defaultMessage: 'Type' })} />
          <FormicaSearchSelectBox
            value={(action as ApiActionJsonModel).auth}
            disabled={!RoleHelper.canEdit('Action')}
            options={this.getAuthTypes()}
            onChange={(e: FormicaSelectBoxItem) => this.setAuthType(e.value as AuthType)}
            rounded
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.authType', defaultMessage: ' Auth Type' })}
            data-testid={`${ComponentName.ACTION}_auth_type_select`}
          />
          {(action as ApiActionJsonModel).auth === AuthType.NO_AUTH && <NoAuthComponent />}
          {(action as ApiActionJsonModel).auth === AuthType.BASIC && <BasicAuthComponent disabled={!RoleHelper.canEdit('Action')} />}
          {(action as ApiActionJsonModel).auth === AuthType.BEARER && <BearerAuthComponent disabled={!RoleHelper.canEdit('Action')} />}
        </div>
      </div>
    );
  }

  public componentDidMount() {
    const {
      action: { action },
      changeAction,
    } = this.props;
    if (!(action as ApiActionJsonModel).headers) return;
    const token = (action as ApiActionJsonModel).headers['Authorization'] || '';
    if (token == undefined) return;
    if (token) {
      const tokenType = token.split(' ')[0];
      switch (tokenType) {
        case 'Bearer':
          (action as ApiActionJsonModel).auth = AuthType.BEARER;
          changeAction(action);
          break;
        case 'Basic':
          (action as ApiActionJsonModel).auth = AuthType.BASIC;
          changeAction(action);
          break;
        default:
          (action as ApiActionJsonModel).auth = AuthType.NO_AUTH;
          changeAction(action);
      }
    }
  }

  private setAuthType = (authType: AuthType) => {
    const {
      action: { action },
      changeAction,
    } = this.props;
    (action as ApiActionJsonModel).auth = authType;
    changeAction(action);
  };

  private getAuthTypes = () => {
    return [
      {
        label: LanguageUtil.get({ id: 'common.label.noAuth', defaultMessage: ' No Auth' }),
        value: AuthType.NO_AUTH,
      },
      {
        label: LanguageUtil.get({ id: 'common.label.basicAuth', defaultMessage: ' Basic Auth' }),
        value: AuthType.BASIC,
      },
      {
        label: LanguageUtil.get({ id: 'common.label.bearerToken', defaultMessage: ' Bearer Token' }),
        value: AuthType.BEARER,
      },
    ];
  };
}

interface Props extends ReduxProps {}

export enum AuthType {
  NO_AUTH = 'No Auth',
  BASIC = 'Basic Auth',
  BEARER = 'Bearer Token',
}

interface Props extends ReduxProps, FormicaProps {}

const mapStateToProps = (state: RootState) => ({
  action: state.action as ActionState,
  isUpdate: state.action.isUpdate,
  lastCategory: state.page.lastCategory,
});
const mapDispatchToProps = {
  changeActionIsUpdate,
  changeAction,
  clearAction,
  enterComponent,
  leaveComponent,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(ApiAuthorizationComponent));
